// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";

type $Props = {
  children: any,
  classes: Object,
};

const TipsContainer = ({ children, classes }: $Props) => (
  <div className={classes.root}>{children}</div>
);

const styles = () => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    margin: "0 auto",
    padding: "0 15px 24px 15px",
    width: "100%",
    maxWidth: "1000px",
  },
});

export default withStyles(styles)(TipsContainer);
